import React from 'react';
import { css } from '@emotion/css';
import { Skeleton } from 'is24-corecss';
import { GRAY100, INFOGRAPHICS_CHARCOAL20 } from '@/domain/colors';

const styles = {
  card: {
    height: '172px',
    width: '100%',
    flex: '1 1 0',
    minWidth: '276px',
    display: 'flex',
    gap: '8px',
    padding: '28px 24px',
    backgroundColor: GRAY100,
    alignItems: 'start',
    boxSizing: 'border-box',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      borderRadius: 'var(--border-radius-600)',
      border: `1px solid ${INFOGRAPHICS_CHARCOAL20}`,
      pointerEvents: 'none',
    },
  },
  cardContent: css`
    display: flex;
    flex-direction: column;
  `,
} as const;

const ProductSelectionCardSkeleton: React.FC = () => {
  return (
    <div className={`${css(styles.card)} absolute-reference`}>
      <div className='margin-s'>
        <Skeleton type='circle' radius='22px' />
      </div>
      <div className={styles.cardContent}>
        <Skeleton className='margin-bottom-s' type='rounded' width='125px' height='26px' />
        <Skeleton className='margin-bottom-m' type='rounded' width='170px' height='24px' />
        <Skeleton className='margin-bottom-s' type='rounded' width='125px' height='20px' />
        <Skeleton type='rounded' width='100px' height='20px' />
      </div>
    </div>
  );
};
export default ProductSelectionCardSkeleton;
